import {
  FETCH_QUEUE_METRICS_ATTEMPT,
  FETCH_QUEUE_METRICS_SUCCESS,
  FETCH_QUEUE_METRICS_ERROR,
  FETCH_QUEUE_SUMMARY_ATTEMPT,
  FETCH_QUEUE_SUMMARY_SUCCESS,
  FETCH_QUEUE_SUMMARY_ERROR,
  FETCH_QUEUE_JOBS_ATTEMPT,
  FETCH_QUEUE_JOBS_SUCCESS,
  FETCH_QUEUE_JOBS_ERROR,
  TRUNCATE_QUEUE_ATTEMPT,
  TRUNCATE_QUEUE_SUCCESS,
  TRUNCATE_QUEUE_ERROR,
  TRUNCATE_QUEUE_RESET_STATE,
} from "../actionTypes/actionTypes";

const initialState = {
  metrics: {
    data: null,
    attempt: false,
    success: false,
    error: null,
  },
  summary: {
    data: null,
    attempt: false,
    success: false,
    error: null,
  },
  jobs: {
    data: {
      data: [], // ResourceList expects 'data' property with array of items
      total: 0,
      page: 1,
      perPage: 20,
      totalPages: 0,
    },
    attempt: false,
    success: false,
    error: null,
  },
  truncate: {
    attempt: false,
    success: false,
    error: null,
    data: null,
  },
};

const intervendQueueReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_QUEUE_METRICS_ATTEMPT:
      return {
        ...state,
        metrics: {
          ...state.metrics,
          attempt: true,
          success: false,
          error: null,
        },
      };
    case FETCH_QUEUE_METRICS_SUCCESS:
      return {
        ...state,
        metrics: {
          data: action.payload,
          attempt: false,
          success: true,
          error: null,
        },
      };
    case FETCH_QUEUE_METRICS_ERROR:
      return {
        ...state,
        metrics: {
          ...state.metrics,
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case FETCH_QUEUE_SUMMARY_ATTEMPT:
      return {
        ...state,
        summary: {
          ...state.summary,
          attempt: true,
          success: false,
          error: null,
        },
      };
    case FETCH_QUEUE_SUMMARY_SUCCESS:
      return {
        ...state,
        summary: {
          data: action.payload,
          attempt: false,
          success: true,
          error: null,
        },
      };
    case FETCH_QUEUE_SUMMARY_ERROR:
      return {
        ...state,
        summary: {
          ...state.summary,
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case FETCH_QUEUE_JOBS_ATTEMPT:
      return {
        ...state,
        jobs: {
          ...state.jobs,
          attempt: true,
          success: false,
          error: null,
        },
      };
    case FETCH_QUEUE_JOBS_SUCCESS:
      return {
        ...state,
        jobs: {
          data: {
            data: action.payload.jobs, // Map 'jobs' array to 'data' for ResourceList
            total: action.payload.total,
            page: action.payload.page,
            perPage: action.payload.perPage,
            totalPages: action.payload.totalPages,
          },
          attempt: false,
          success: true,
          error: null,
        },
      };
    case FETCH_QUEUE_JOBS_ERROR:
      return {
        ...state,
        jobs: {
          ...state.jobs,
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case TRUNCATE_QUEUE_ATTEMPT:
      return {
        ...state,
        truncate: {
          attempt: true,
          success: false,
          error: null,
          data: null,
        },
      };
    case TRUNCATE_QUEUE_SUCCESS:
      return {
        ...state,
        truncate: {
          attempt: false,
          success: true,
          error: null,
          data: action.payload,
        },
      };
    case TRUNCATE_QUEUE_ERROR:
      return {
        ...state,
        truncate: {
          attempt: false,
          success: false,
          error: action.payload,
          data: null,
        },
      };
    case TRUNCATE_QUEUE_RESET_STATE:
      return {
        ...state,
        truncate: {
          attempt: false,
          success: false,
          error: null,
          data: null,
        },
      };
    default:
      return state;
  }
};

export default intervendQueueReducer;

